// `Symbol.hasInstance` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.hasinstance
require('../internals/define-well-known-symbol')('hasInstance');